import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const AboutMe = () => {
  return (
    <div className="p-6 lg:px-20 bg-gradient-to-r from-teal-900 to-stone-900 text-white">
      <h1 className="text-3xl lg:text-4xl font-semibold text-center uppercase text-info my-8">
        About Me
      </h1>

      <div
        className="grid grid-cols-1 lg:grid-cols-12 gap-12"
        data-aos="fade-up"
      >
        <div className="lg:col-span-10">
          <h2 className="text-2xl font-semibold mb-4 pb-2 text-center lg:text-left border-b-2 border-gray-500">
            My Story
          </h2>
          <p className="text-left mb-8">
            I have come from a non-Computer Science background, but my passion
            for technology, problem-solving, and creating impactful digital
            experiences led me to explore web development. I've dedicated myself
            to mastering a wide range of technologies and frameworks, enabling
            me to build robust and user-friendly web applications. My special
            services for you:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <div className="flex items-center">
              <FaCheckCircle className="text-info mr-2" />
              <span>Front End Development</span>
            </div>
            <div className="flex items-center">
              <FaCheckCircle className="text-info mr-2" />
              <span>Back End Development</span>
            </div>
            <div className="flex items-center">
              <FaCheckCircle className="text-info mr-2" />
              <span>Full Stack Development</span>
            </div>
            <div className="flex items-center">
              <FaCheckCircle className="text-info mr-2" />
              <span>MERN Stack Development</span>
            </div>
          </div>
          <h2 className="text-2xl font-semibold mb-4 pb-2 text-center lg:text-left border-b-2 border-gray-500">
            Personal Information
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <p>
                <strong>Name:</strong> Resma Islam Upoma
              </p>
              <p>
                <strong>Age:</strong> 30 Years
              </p>
              <p>
                <strong>Nationality:</strong> Bangladeshi
              </p>
              <p>
                <strong>Freelance:</strong> Available
              </p>
            </div>
            <div>
              <p>
                <strong>Address:</strong> Dhaka, Bangladesh
              </p>
              <p>
                <strong>Phone:</strong>{" "}
                <a
                  href="tel:+8801902996169"
                  className="text-info hover:underline"
                >
                  +8801902996169
                </a>
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:upoma.cdsr@mail.com"
                  className="text-info hover:underline"
                >
                  upoma.cdsr@mail.com
                </a>
              </p>
              <p>
                <strong>Languages:</strong> Bangla, English, Hindi
              </p>
            </div>
          </div>
        </div>
        <div className="lg:col-span-2">
          <div className="stats stats-vertical shadow bg-transparent">
            <div className="stat" data-aos="fade-up">
              <div className="stat-title">Total Projects</div>
              <div className="stat-value">30+</div>
            </div>
            <div className="stat" data-aos="fade-up">
              <div className="stat-title">Completed</div>
              <div className="stat-value">20</div>
            </div>
            <div className="stat" data-aos="fade-up">
              <div className="stat-title">Pending</div>
              <div className="stat-value">10</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
